import { HttpClient } from '@angular/common/http';
import { Component, Injectable, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { jkLib } from 'jk-service';

export class weatherData{
  city: string = '';
  currentTime: string = ''; // 現在時間
  nowDate:string = '';
  shortMessage: string ='';
  longMessage: string ='';
  description: string =''; // 天氣描述. 晴 多雲 ...
  temperature: number =0; //  + ' 溫度:' +
  feels_like: number =0; // ' 體感溫度:'
  temperature_min : number =0;  // ' 最低:'
  temperature_max: number =0;  //' 最高:' +
  pressure: number=0; //' 氣壓:' +
  humidity: string=''; //濕度%
  wind_speed: number =0; // 風速
  wind_deg: number = 0; //0~360 data.wind.deg;
  wind_direction: string =''; // degreeName(data.wind.deg); // ' 風向:' +
  clouds: number=0; // 雲量
  sunrise: string=''; //12:34  = jkLib.timeStamp2Time5(data.sys.sunrise); // ' 日出:' +
  sunset: string=''; // = jkLib.timeStamp2Time5(data.sys.sunset); // ' 日落:'
  sunset_time: string='';
  time: string=''; // jkLib.timeStamp2Time5(data.dt);//' 天氣時間:'
  isDay: boolean = true;
}

@Injectable()
export class WeatherService {
  data: weatherData;
  /*shortMessage: string;
  longMessage: string;
  description: string; // 天氣描述. 晴 多雲 ...
  temperature: number; //  + ' 溫度:' +
  feels_like: number; // ' 體感溫度:'
  temperature_min: number;  // ' 最低:'
  temperature_max: number;  //' 最高:' +
  pressure: number; //' 氣壓:' +
  humidity: string; //濕度%
  wind_speed: number; // 風速
  wind_deg: number; //0~360 data.wind.deg;
  wind_direction: string; // degreeName(data.wind.deg); // ' 風向:' +
  clouds: number; // 雲量
  sunrise: string; //12:34  = jkLib.timeStamp2Time5(data.sys.sunrise); // ' 日出:' +
  sunset: string; // = jkLib.timeStamp2Time5(data.sys.sunset); // ' 日落:'
  time: string; // jkLib.timeStamp2Time5(data.dt);//' 天氣時間:' */
  constructor(private http: HttpClient) {
    this.data = new weatherData();
  }
  getWeather(city: string = 'Taichung') {
    this.data.city = city;
    let hostName = 'https://api.openweathermap.org';
    let url = '/data/2.5/weather?' +
      'units=metric&q=' + city + ',,TW&appid=55c919d2beed3ce7d65a1cc85c1314af&lang=zh_tw';

    //let fetchRet = await jkLib.doFetch(hostName, url, '', '', 'get', {});
    return this.http.get(hostName + url);
    //return this.http.get(hostName + url).pipe(data => this.parseWeather(data));
    ;
  }
  getWeather2(city: string = 'Taichung'): string {
    this.data.city = city;
    let hostName = 'https://api.openweathermap.org';
    let url = '/data/2.5/weather?' +
      'units=metric&q=' + city + ',,TW&appid=55c919d2beed3ce7d65a1cc85c1314af&lang=zh_tw';

    let s = this.http.get(hostName + url);
    s.subscribe((data) => {
      return this.parseWeather(data);
    })
      ;
    return this.data.shortMessage;
  }
  parseWeather(data: any): string {
    /**{
    "coord": {
        "lon": 120.6839,
        "lat": 24.1469
    },
    "weather": [
        {
            "id": 802,
            "main": "Clouds",
            "description": "多雲",
            "icon": "03d"
        }
    ],
    "base": "stations",
    "main": {
        "temp": 26.66,
        "feels_like": 26.66,
        "temp_min": 24.7,
        "temp_max": 26.73,
        "pressure": 1007,
        "humidity": 61
    },
    "visibility": 10000,
    "wind": {
        "speed": 2.06,
        "deg": 20
    },
    "clouds": {
        "all": 40
    },
    "dt": 1666834939,
    "sys": {
        "type": 2,
        "id": 86663,
        "country": "TW",
        "sunrise": 1666821624,
        "sunset": 1666862503
    },
    "timezone": 28800,
    "id": 1668399,
    "name": "Taichung",
    "cod": 200
    } */
    let str = '';
    try {
      this.data.description = data.weather[0].description; // '天氣:'
      this.data.temperature = data.main.temp; //  + ' 溫度:' +
      this.data.feels_like = data.main.feels_like; // ' 體感溫度:'
      this.data.temperature_min = data.main.temp_min; // ' 最低:'
      this.data.temperature_max = data.main.temp_max;  //' 最高:' +
      this.data.pressure = data.main.pressure; //' 氣壓:' +
      this.data.humidity = data.main.humidity + '%'; // ' 濕度:'
      this.data.wind_speed = data.wind.speed;// 風速
      this.data.wind_deg = data.wind.deg;
      this.data.wind_direction = this.degreeName(data.wind.deg); // ' 風向:' +
      this.data.clouds = data.clouds.all; //' 雲量:' +
      this.data.sunrise = jkLib.timeStamp2Time5(data.sys.sunrise); // ' 日出:' +
      this.data.sunset = jkLib.timeStamp2Time5(data.sys.sunset); // ' 日落:'
      this.data.time = jkLib.timeStamp2Time5(data.dt);//' 天氣時間:'
      let sunsetTime = new Date(data.sys.sunset * 1000);
      this.data.sunset_time = sunsetTime.toLocaleTimeString();
      let currentDate = new Date();
      this.data.isDay = (currentDate.getTime() < sunsetTime.getTime());

      this.data.shortMessage = '天氣:' + data.weather[0].description +
        ' 溫度:' + data.main.temp +
        ' 濕度:' + data.main.humidity +
        ' 雲量:' + data.clouds.all +
        ' 天氣時間:' + jkLib.timeStamp2Time5(data.dt);
      this.data.longMessage = '天氣:' + data.weather[0].description +
        ' 溫度:' + data.main.temp +
        ' 體感溫度:' + data.main.feels_like +
        ' 最低:' + data.main.temp_min +
        ' 最高:' + data.main.temp_max +
        ' 氣壓:' + data.main.pressure +
        ' 濕度:' + data.main.humidity +
        '% 風速:' + data.wind.speed +
        ' 風向:' + this.degreeName(data.wind.deg) +
        ' 雲量:' + data.clouds.all +
        ' 日出:' + jkLib.timeStamp2Time5(data.sys.sunrise) +
        ' 日落:' + jkLib.timeStamp2Time5(data.sys.sunset) +
        ' 天氣時間:' + jkLib.timeStamp2Time5(data.dt);
    } catch (error:any) {
      str = error.message;
    }
    return this.data.shortMessage;
  }
  degreeName(d: number): string {
    let dir = '';
    //Degree. Common. 330, 340. N/NW. 310, 320. NW. 290, 300. W/NW. 260, 270, 280. W. 240, 250. W/SW. 220, 230. SW. 200, 210. S/SW. 170, 180, 190.
    switch (d) {
      case 0: case 10: case 20: case 340: case 350: case 360:
        dir = '北';
        break;
      case 30: case 40: case 50: case 60:
        dir = '東北';
        break;
      case 70: case 80: case 90: case 100: case 110:
        dir = '東';
        break;
      case 120: case 130: case 140: case 150:
        dir = '東南';
        break;
      case 160: case 170: case 180: case 190: case 200:
        dir = '南';
        break;
      case 210: case 220: case 230: case 240:
        dir = '西南';
        break;
      case 250: case 260: case 270: case 280: case 290:
        dir = '西';
        break;
      case 300: case 310: case 320: case 330:
        dir = '西北';
        break;
    }
    return dir;
  }
}



@Component({
  selector: 'app-weather-widget',
  templateUrl: './weather-widget.component.html',
  styleUrls: ['./weather-widget.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class WeatherWidgetComponent implements OnInit {

  //WeatherData:any;
  public weather:WeatherService;
  constructor(private http: HttpClient) {
    this.weather = new WeatherService(http);
   }

  async ngOnInit() {
    /*
    this.WeatherData = {
      main : {},
      date: '',
      isDay: true
    };*/
    let s = await this.weather.getWeather2();
    //this.getWeatherData();

    setInterval(() =>{
      const currentDate = new Date();
      this.weather.data.currentTime = currentDate.toLocaleTimeString();
      this.weather.data.nowDate = jkLib.nowDate10('/');
       }, 1000);

    setInterval(()=>{
      //this.getWeatherData();
      this.weather.getWeather2();
    },1000*60*30);
  }
  /*
  getWeatherData(city:string='Taichung,,TW',appid:string='55c919d2beed3ce7d65a1cc85c1314af'):string{
    //       'units=metric&q=' + city + ',,TW&appid=55c919d2beed3ce7d65a1cc85c1314af&lang=zh_tw';
    //fetch('https://api.openweathermap.org/data/2.5/weather?q=mumbai&appid=ff1bc4683fc7325e9c57e586c20cc03e')
    fetch('https://api.openweathermap.org/data/2.5/weather?units=metric&q='+ city +'&appid='+appid+'&lang=zh_tw')
    .then(response=>response.json())
    .then(data=>{this.setWeatherData(data);})
    .finally(()=>{
      return 'ok';
    })
    return 'ok2';
    // let data = JSON.parse('{"coord":{"lon":72.85,"lat":19.01},"weather":[{"id":721,"main":"Haze","description":"haze","icon":"50n"}],"base":"stations","main":{"temp":297.15,"feels_like":297.4,"temp_min":297.15,"temp_max":297.15,"pressure":1013,"humidity":69},"visibility":3500,"wind":{"speed":3.6,"deg":300},"clouds":{"all":20},"dt":1580141589,"sys":{"type":1,"id":9052,"country":"IN","sunrise":1580089441,"sunset":1580129884},"timezone":19800,"id":1275339,"name":"Mumbai","cod":200}');
    // this.setWeatherData(data);
  }

  setWeatherData(data){
    this.WeatherData = data;
    let sunsetTime = new Date(this.WeatherData.sys.sunset * 1000);
    this.WeatherData.sunset_time = sunsetTime.toLocaleTimeString();
    let currentDate = new Date();
    this.WeatherData.isDay = (currentDate.getTime() < sunsetTime.getTime());
    this.WeatherData.temp_celcius = (this.WeatherData.main.temp ).toFixed(0);
    this.WeatherData.temp_min = (this.WeatherData.main.temp_min ).toFixed(0);
    this.WeatherData.temp_max = (this.WeatherData.main.temp_max ).toFixed(0);
    this.WeatherData.temp_feels_like = (this.WeatherData.main.feels_like ).toFixed(0);
  }
  */
}
